//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import editDialog from './edit';
import MessageBox from '@/components/messageBox';
import { mapGetters } from 'vuex';

export default {
  components: { editDialog, MessageBox },
  data() {
    return {
      listData: [],
      filterListData: [],
      appOptions: [],
      oldSearchObj: {},
      searchObj: {
        appid: Number(this.$route.query.appid) || 0,
        keyword: '',
      },
      highlightKeyword: '',
      editRow: '',
      editVisible: false,
      tableHeight: '',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        orgManage: this.getElementList.includes('org-manage'),
      };
    },
    columns() {
      const list = [
        {
          colKey: 'name',
          title: '名称',
          minWidth: 240,
          fixed: 'left',
        },
        {
          colKey: 'code',
          title: 'Code',
          minWidth: 140,
        },
        {
          colKey: 'parent_code',
          title: '直属上级',
          minWidth: 140,
        },
        {
          colKey: 'description',
          title: '备注',
        },
        {
          colKey: 'create_by',
          title: '创建人',
        },
        {
          colKey: 'update_by',
          title: '最后修改人',
        },
        {
          colKey: 'update_time',
          title: '修改时间',
        },
        {
          colKey: 'create_time',
          title: '创建时间',
        },
      ];

      if (this.jurisdiction.orgManage) {
        list.push({
          colKey: 'operation',
          title: '操作',
          minWidth: 100,
        });
      }

      return list;
    },
  },
  async mounted() {
    if (!this.searchObj.appid) {
      this.searchObj.appid = Number(sessionStorage.getItem('app_id'));
    } else {
      sessionStorage.setItem('app_id', this.searchObj.appid);
    }
    await this.loadAppOption();
    this.loadListData(true);
    const totalHeight = document.body.clientHeight;
    const formHeight = document.querySelector('.top').clientHeight;
    const navBarHeight = document.querySelector('.navbar').clientHeight;
    this.tableHeight = `${totalHeight - formHeight - navBarHeight - 60}px`;
    console.log('---tableHeight---', this.tableHeight);
  },
  methods: {
    async loadListData(refresh = false) {
      if (refresh) {
        this.listData = [];
        this.filterListData = [];
      }
      console.log('-keyword-', this.searchObj.keyword, refresh);
      this.highlightKeyword = this.searchObj.keyword;
      if (refresh || this.searchObj.appid !== this.oldSearchObj.appid) {
        const url = this.$api.getOrganizationTree;
        const data = {
          appid: this.searchObj.appid,
        };
        const resp = await this.$request({ url, data });
        this.oldSearchObj = {
          ...this.searchObj,
        };
        this.listData = resp.data;
        this.filterListData = this.filterList(this.listData, this.searchObj);
      }
      if (this.searchObj.keyword !== this.oldSearchObj.keyword) {
        this.filterListData = this.filterList(this.listData, this.searchObj);
        console.log('---this.filterListData---', this.filterListData);
        this.oldSearchObj = {
          ...this.searchObj,
        };
      }
    },
    resetForm() {
      this.searchObj = {
        appid: this.appOptions[0]?.id || 0,
        keyword: this.$route.query.keyword || '',
      };
      this.loadListData();
    },
    filterList(tree, { keyword = '' }) {
      return tree.filter((item) => {
        const condition = [item.name, item.code].find((val) => {
          return val.includes(keyword);
        });
        // 显示状态
        if (condition) {
          return true;
        }
        if (item.children && item.children.length > 0) {
          return this.filterList(item.children, { keyword }).length > 0;
        }
        return false;
      });
    },
    loadAppOption() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const cb = (data) => {
        this.appOptions = data.data;
        this.searchObj.appid = this.searchObj.appid || this.appOptions[0].id;
      };
      this.$request({ url, data, cb });
    },
    handleAdd() {
      this.editRow = '';
      this.editVisible = true;
    },
    handleEdit({ id }) {
      this.editRow = id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$refs.messageBox.show({
        title: `确定要删除${row.name}吗？`,
        content: `删除后，${row.name}将失效`,
        titleIconType: 'warning',
        confirmText: '确认删除',
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$request({
            url: this.$api.deleteOrganizationInfo,
            data: { id: row.id },
          }).then(() => {
            this.$message.success('删除成功');
            this.$refs.messageBox.close();
            this.loadListData(true);
          });
        },
      });
    },
    editSuccess() {
      this.editVisible = false;
      this.loadListData(true);
    },
  },
};
